/**
 * Premium monthly is level 40. Registration and every Essential plan sit below
 * that, including future promotional Essential codes.
 */
const PREMIUM_PLAN_LEVEL = 40;

type HeadshotsPlan = {
  level?: number | null;
} | null;

type FreeHeadshotsSubscription = {
  plan?: HeadshotsPlan;
} | null;

/**
 * True when the plan is missing or below Premium. Those subscribers must upgrade
 * before they can book a complimentary headshot session. An annual Premium plan
 * that was canceled mid term stays at Premium level until it expires.
 */
export const isBelowPremiumHeadshotsPlan = (plan?: HeadshotsPlan): boolean =>
  !plan || plan.level == null || plan.level < PREMIUM_PLAN_LEVEL;

export const isFreeHeadshotsSubscriber = (subscription?: FreeHeadshotsSubscription): boolean =>
  isBelowPremiumHeadshotsPlan(subscription?.plan);
